import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const PartnersService = {
  async getAllPartners() {
    let response = await $axios.get($api("partners")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addPartner(payload: any) {
    try {
      const { data, status } = await $axios.post($api("partners"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updatePartner(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("partners_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deletePartner(id: string) {
    let { data, status } = await $axios
      .delete($api("partners_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
